module.exports = __webpack_public_path__ + "img/aeroland-app-showcase-image-03.98522e25.jpg";